import styled from 'styled-components';

export const PHONE_SIZE = {
  HEIGHT: 500,
  WIDTH: 250,
  SCREEN_HEIGHT: 400
};

export const COMMON_COLOR = {
  BLACK: '#000',

  BODY_BG_CAMPAIGN: '#F0F2F5',
  GREY: '#262626',
  GREY_1: '#f5f5f5',
  GREY_2: '#E8E8E8',
  GREY_3: '#595959',
  GREY_4: '#F8F8F8',
  GREY_7: '#BFBFBF',
  GREY_6: '#8C8C8C',
  GREY_5: '#9b9b9b',

  GREY_QUITE: '#212121',

  BORDER: '#595959',
  QUITE_BORDER: '#D9D9D9',
  WHITE: '#fff',
  WHITE_1: '#c5d3ea',
  BLUE: '#2665EE',
  BLUE_1: '#202c46',
  BLUE_2: '#2664ED',

  BLUE_QUITE: '#E3F3FF'
};

export const RADIUS_BUTTON = {
  LARGE: 25,
  SMALL: 10,
  MINI: 5
};

export const PhonePreviewWrapperStyled = styled.section`
  display: flex;

  justify-content: flex-end;
  flex-direction: column;
  align-items: center;
`;

export const PhonePreviewLandingPageStyled = styled.article`
  background: ${COMMON_COLOR.BLACK};
  height: ${PHONE_SIZE.SCREEN_HEIGHT}px;
  border-radius: ${RADIUS_BUTTON.MINI};

  h3 {
    font-size: 16px;
    font-weight: bold;
    color: ${COMMON_COLOR.WHITE};
  }

  p {
    color: ${COMMON_COLOR.GREY_7};
    word-break: break-all;
  }
`;

export const PhonePreviewLandingPageContentStyled = styled.div`
  padding: 10px;
`;

export const PhonePreviewContentIconStyled = styled.article<IImagePreviewProps>`
  background: ${({ imageUrl }) => (imageUrl ? `url(${imageUrl})` : COMMON_COLOR.WHITE)} repeat
    center center;
  padding: 10px;
  margin: 20px 10px;
  border-radius: ${RADIUS_BUTTON.MINI}px;
  text-align: center;

  h2 {
    font-size: 14px;
  }

  p {
    font-size: 12px;
    word-break: break-all;
  }
`;

interface IImagePreviewProps {
  imageUrl?: string;
}

export const ImagePreviewStyled = styled.div<IImagePreviewProps>`
  background: ${({ imageUrl }) => (imageUrl ? `url(${imageUrl})` : COMMON_COLOR.GREY_7)} repeat;
  width: 100%;
  height: 140px;
  border-radius: ${RADIUS_BUTTON.SMALL}px;
  margin-bottom: 20px;
`;

export const ButtonStartLandingPageStyled = styled.button`
  border: none;
  outline: none;
  cursor: pointer;
  color: ${COMMON_COLOR.WHITE};
  background: ${COMMON_COLOR.BLUE};
  border-radius: ${RADIUS_BUTTON.SMALL}px;
  text-align: center;
  padding: 5px;
  width: 100%;
`;

export const PhonePreviewStyled = styled.section`
  background: ${COMMON_COLOR.GREY};
  width: ${PHONE_SIZE.WIDTH}px;
  height: ${PHONE_SIZE.HEIGHT}px;
  border-radius: ${RADIUS_BUTTON.LARGE}px;
  padding: 45px 10px;
  overflow-y: hidden;
`;

export const PhonePreviewScreenStyled = styled.div<IImagePreviewProps>`
  background: ${({ imageUrl }) => (imageUrl ? `url(${imageUrl})` : COMMON_COLOR.GREY)};
  height: ${PHONE_SIZE.SCREEN_HEIGHT}px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export const CampaignNameStyled = styled.h2`
  background: ${COMMON_COLOR.BLUE};
  color: ${COMMON_COLOR.WHITE};
  text-align: center;
  font-size: 12px;
  padding: 10px;
  margin-bottom: 0;
  position: relative;

  svg {
    position: absolute;
    left: 5px;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const CommonTitleH3Styled = styled.h3`
  color: ${COMMON_COLOR.GREY};
  margin-bottom: 10px;
`;

export const IconWrapperStyled = styled.ul`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  justify-content: center;
  padding: 0;
  margin: 0;

  li {
    width: 33.33%;
    text-align: center;
    padding: 10px;

    img {
      max-width: 100%;
      object-fit: cover;
    }
  }
`;
